import React, {useEffect, useState} from "react";
import s from "./styles.module.css"
import {MenuItem, Select} from "@mui/material";
import classNames from "classnames";

const DynamicFormulas = ({scoreCommand}) => {

    const [dynamicFormulas, setDynamicFormulas] = useState(null);

    const [selectedFormula, setSelectedFormula] = useState(null);

    useEffect(() => {
        setDynamicFormulas(scoreCommand?.dynamic_formulas);
        setSelectedFormula(scoreCommand?.dynamic_formulas[0]);
    }, [scoreCommand]);

    return (
        <div className={s.dynamic_formulas_container}>
            <Select
                placeholder={'Суммарная формула'}
                displayEmpty
                value={selectedFormula}
                onChange={(e) => {
                    setSelectedFormula(e.target.value)
                }}
                inputProps={{'aria-label': 'Without label'}}
                sx={{
                    height: '45px',
                    width: '79%',
                    backgroundColor: '#fff'
                }}
                labelId="demo-simple-select-label"
            >
                {dynamicFormulas?.map((el) => <MenuItem key={el}
                                                        value={el}>{`${el?.formula_name}`}</MenuItem>)}
            </Select>
            <div className={s.dynamic_scores}>
                <p>Score</p>

                <div className={s.main_table_score_score}>
                    {Number(scoreCommand?.result_total).toFixed(4)}
                </div>
            </div>
            {selectedFormula?.formula_components?.map((item) => (
                <div key={item.discipline_id} className={s.dynamic_items}>
                    <div
                        className={classNames(s.main_table_score_score, s.main_table_score_score_sub)}>
                        {Number(item.discipline_result).toFixed(4)}
                    </div>

                    <h3>{item.discipline_name}</h3>
                </div>
            ))}
            <div className={classNames(s.fixed_bottom)}>
                <h3 style={{fontWeight: '700'}}>{scoreCommand?.result_sum_title}</h3>

                <div style={{fontWeight: '700'}}
                     className={classNames(s.main_table_score_score, s.main_table_score_score_sub)}>
                    {Number(selectedFormula?.sum_result).toFixed(4)}
                </div>
            </div>
        </div>
    );
}

export default DynamicFormulas;
